import i18n from 'src/configs/i18n';

export const ROLE_ADMIN = 1;
export const ROLE_STAFF = 2;
export const ROLE_SUPER_ADMIN = 3;
export const ROLE_APPADMIN = 4;
export const ROLE_MANAGER = 5;
export const ROLE_SELLER = 6;
export const ROLE_PROMOTER = 7;
export const ROLE_PHOTOGRAPHER = 8;
export const ROLE_FINANCE_MANAGER = 9;

export const ROLES = {
  ADMIN: ROLE_ADMIN,
  STAFF: ROLE_STAFF,
  SUPER_ADMIN: ROLE_SUPER_ADMIN,
  APPADMIN: ROLE_APPADMIN,
  MANAGER: ROLE_MANAGER,
  SELLER: ROLE_SELLER,
  PROMOTER: ROLE_PROMOTER,
  PHOTOGRAPHER: ROLE_PHOTOGRAPHER,
  FINANCE_MANAGER: ROLE_FINANCE_MANAGER,
};

export const WEBAPP_ROLES = [ROLE_APPADMIN, ROLE_MANAGER];

export const getRoleName = (id: number): string => {
  switch (id) {
    case ROLES.APPADMIN: {
      return i18n.t('accountScreen:appadmin');
    }
    case ROLES.MANAGER: {
      return i18n.t('accountScreen:manager');
    }
    case ROLES.SELLER: {
      return i18n.t('accountScreen:seller');
    }
    case ROLES.PROMOTER: {
      return i18n.t('accountScreen:promoter');
    }
    case ROLES.SUPER_ADMIN: {
      return i18n.t('accountScreen:super_admin');
    }
    case ROLES.ADMIN: {
      return i18n.t('accountScreen:admin');
    }
    case ROLES.STAFF: {
      return i18n.t('accountScreen:staff');
    }
    case ROLES.PHOTOGRAPHER: {
      return i18n.t('accountScreen:photographer');
    }
    case ROLES.FINANCE_MANAGER: {
      return i18n.t('accountScreen:finance_manager');
    }
    default:
      return '';
  }
};

export const LOCAL_STORAGE_AUTH_STATE = 'inv360-auth-state';
